// ---------------------------------------------------------------------------
// Block Definition: legend
//
// Horizontal legend of colored swatches + labels.  Pure layout — no data extraction.
// ---------------------------------------------------------------------------

export const legendDef = {
  type: "legend",
  label: "Legend",
  description: "Horizontal row of colored swatches with labels for status keys.",

  crystallizer: null,

  renderer: null, // wired by ui/src/blockRegistryInit.js

  editor: {
    icon: "palette",
    category: "layout",
    defaultTemplate: {
      type: "legend",
      items: [
        { color: "#2D8659", label: "On track" },
        { color: "#BA7517", label: "Watch" },
        { color: "#C4463A", label: "Off track" },
      ],
    },
  },
};
